import React, { useState, useEffect } from "react";

import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./credits.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import debounce from "lodash/debounce";
import {
  getAllItemsSearch,
  getAllPartySearch,
  getSingleItem,
} from "../../api/endpoints/search";
import {
  getPartyByCoupon,
  getVehicalByParty,
  getVehicalDetail,
  getLatestCoupon,
  saveData,
  getDataByEnteredOn,
  getDataByCoupon,
  updateSale,
  deleteSingleCoupon,
  deleteByDate,
  descCreditSale,
  ascCreditSale,
  oneDayPrevious,
  oneDayNext,
} from "../../api/endpoints/credit.js";
import { getSiteRefrence } from "../../api/endpoints/refrences";
import { getRate } from "../../api/endpoints/specialRate.js";
import { latestDate } from "../../api/endpoints/meter.js";
import { ECredit } from "../../enums/credit.js";

const { Option } = Select;

const Credits = () => {
  const { user, access_token } = useSelector(authSelector);
  const [latestCoupon, setLatestCoupon] = useState();
  const [editCoupon, setEditCoupon] = useState();
  const [type, setType] = useState("ADD");
  const [typeLast, setTypeLast] = useState("");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [refrences, setRefrences] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();
  const [remainingQuantity, setRemainingQuantity] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const [modal, contextHolder] = Modal.useModal();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [state, setState] = useState({
    items: [],
    parties: [],
    vehicals: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    slipDate: "",
    coupon: "",
    vehical: "",
    vehicalNo: "",
    amount: "",
    saleRate: "",
    actualSaleRate: "",
    quantity: "",
    itemName: "",
    itemCode: "",
    rateDiff: "",
    description: "",
  });

  const clearState = () => {
    setIsVisible(true);
    setState({
      items: state.items,
      parties: state.parties,
      vehicals: state.vehicals,
      // partyId: "", //ac no.
      // partyName: "", // supplier name
      // slipDate: "",
      // coupon: "",
      vehical: "",
      vehicalNo: "",
      amount: "",
      saleRate: "",
      actualSaleRate: "",
      purchaseRate: "",
      quantity: "",
      itemName: "",
      itemCode: "",
      rateDiff: "",
      description: "",
    });
  };

  const clearStates = () => {
    clearState();
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setLatestCoupon("");
    setType("ADD");
    setTypeLast("");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const orderByDesc = async () => {
    const result = await descCreditSale(access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            slipDate: curr.slipDate,
            coupon: curr.couponNo,
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            vehical: Number(curr.vehicalId),
            vehicalNo: curr.vehical.regNumber,
            itemCode: curr.itemCode,
            itemName: curr.item.itemName,
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            amount: Number(curr.amount),
            rateDiff: Number(curr.rateDiff),
            description: curr.description,
            items: state.items,
            parties: state.parties,
            vehicals: state.vehicals,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
      setTypeLast(ECredit.LAST);
    } else {
      message.warning(result.message);
    }
  };

  const orderByAsc = async () => {
    const result = await ascCreditSale(access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            slipDate: curr.slipDate,
            coupon: curr.couponNo,
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            vehical: Number(curr.vehicalId),
            vehicalNo: curr.vehical.regNumber,
            itemCode: curr.itemCode,
            itemName: curr.item.itemName,
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            amount: Number(curr.amount),
            rateDiff: Number(curr.rateDiff),
            description: curr.description,

            items: state.items,
            parties: state.parties,
            vehicals: state.vehicals,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
      setTypeLast(ECredit.LAST);
    } else {
      message.warning(result.message);
    }
  };

  const onePreDate = async () => {
    const payload = {
      enteredOn: dateEntered,
      shift,
    };
    const result = await oneDayPrevious(payload, access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            slipDate: curr.slipDate,
            coupon: curr.couponNo,
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            vehical: Number(curr.vehicalId),
            vehicalNo: curr.vehical.regNumber,
            itemCode: curr.itemCode,
            itemName: curr.item.itemName,
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            amount: Number(curr.amount),
            rateDiff: Number(curr.rateDiff),
            description: curr.description,

            items: state.items,
            parties: state.parties,
            vehicals: state.vehicals,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
    } else {
      message.warning(result.message);
    }
  };

  const oneNextDate = async () => {
    const payload = {
      enteredOn: dateEntered,
      shift,
    };
    const result = await oneDayNext(payload, access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            slipDate: curr.slipDate,
            coupon: curr.couponNo,
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            vehical: Number(curr.vehicalId),
            vehicalNo: curr.vehical.regNumber,
            itemCode: curr.itemCode,
            itemName: curr.item.itemName,
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            amount: Number(curr.amount),
            rateDiff: Number(curr.rateDiff),
            description: curr.description,

            items: state.items,
            parties: state.parties,
            vehicals: state.vehicals,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
    } else {
      message.warning(result.message);
    }
  };

  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
    console.log(_refrences, "_ref");
    setRefrences(_refrences.data);
  };

  const getCouponNo = async () => {
    const latestCoupons = await getLatestCoupon(access_token);
    setLatestCoupon(latestCoupons.data);
    setState((prevState) => ({
      ...prevState,
      coupon: Number(latestCoupons.data),
      // items: _items, // Uncomment and modify this line if you also need to update the items
    }));
  };

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllPartySearch(access_token);
    setState({
      ...state,
      parties: _parties,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();
    getRefrences();
    if (refrences.coupon === "automatic") {
      getCouponNo();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (refrences.coupon === "automatic") {
      getCouponNo();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refrences]);

  console.log(state, "itemqu");
  console.log(refrences, "refff");

  const getSaleRateByCode = async () => {
    try {
      const data = {
        partyId: state.partyId,
        itemCode: state.itemCode,
      };

      const _getSpecialRate = await getRate(data, access_token);

      if (_getSpecialRate && _getSpecialRate.success) {
        const updatedState = {
          saleRate: _getSpecialRate.data.saleRate,
        };

        const _items = await getSingleItem(state.itemCode, access_token);
        if (_items && _items.success) {
          updatedState.purchaseRate = _items.data.purchaseRate;
          updatedState.actualSaleRate = _items.data.saleRate;
        }

        setState((prevState) => ({
          ...prevState,
          ...updatedState,
        }));
      } else {
        // Handle the case where _getSpecialRate.success is false or _getSpecialRate is undefined
        const _items = await getSingleItem(state.itemCode, access_token);
        if (_items && _items.success) {
          setState({
            ...state,
            saleRate: _items.data.saleRate,
            purchaseRate: _items.data.purchaseRate,
            itemName: _items.data.itemName,
            actualSaleRate: _items.data.saleRate,
          });
        } else {
          console.error(
            "Error fetching special rate and item:",
            _getSpecialRate?.message || "Unknown error"
          );
        }
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  useEffect(() => {
    let amountSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.amount || 0),
      0
    );
    setTotal(Number(amountSum.toFixed(2)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  useEffect(() => {
    // if (state.itemCode) {
    //   getSaleRateByCode();
    // }
    if (type === "SAVE") {
      if (state.itemCode) {
        getSaleRateByCode();
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.itemCode]);

  // const getActualSaleRateByCode = async () => {
  //   const _items = await getSingleItem(state.itemCode, access_token);
  //   if (_items.success) {
  //     setState({
  //       ...state,
  //       actualSaleRate: _items.data.saleRate,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (state.itemCode) {
  //     getActualSaleRateByCode();
  //   }
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state.itemCode]);

  // const getSaleRateByCode = async () => {
  //   const _items = await getSingleItem(state.itemCode, access_token);
  //   if (_items.success) {
  //     setState({
  //       ...state,
  //       saleRate: _items.data.saleRate,
  //       purchaseRate: _items.data.purchaseRate,
  //       itemName: _items.data.itemName,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (state.itemCode) {
  //     getSaleRateByCode();
  //   }
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state.itemCode]);

  const getPartyByCoup = debounce(async () => {
    const payload = {
      couponNumber: state.coupon,
    };
    const _party = await getPartyByCoupon(payload, access_token);
    if (_party.success) {
      setState({
        ...state,
        partyId: _party.data.partyId,
        partyName: _party.data.party.partyName,
      });
    } else {
      message.error("Invalid Coupon !");
      setState({
        ...state,
        partyId: "", // Clear the partyId state value
        partyName: "", // Optionally clear other related state values
        vehical: "",
      });
    }
  }, 300);

  useEffect(() => {
    if (state.coupon && refrences.coupon === "issued") {
      getPartyByCoup();
    }

    return () => getPartyByCoup.cancel();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.coupon]);

  const getVehicalByPartyId = async () => {
    const payload = {
      partyId: state.partyId,
    };
    const vehical = await getVehicalByParty(payload, access_token);
    if (vehical.success) {
      setState({
        ...state,
        vehicals: vehical.data,
        // partyName: vehical.data.party.partyName,
      });
    }
  };

  useEffect(() => {
    if (state.partyId) {
      getVehicalByPartyId();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.partyId]);

  const getVehicalDetails = async () => {
    const vehical = await getVehicalDetail(state.vehical, access_token);
    if (vehical.success) {
      setState({
        ...state,
        itemCode: vehical.data.itemCode,
        itemName: vehical.data.item.itemName,
      });
    }
  };

  useEffect(() => {
    if (state.vehical) {
      getVehicalDetails();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.vehical]);

  const transferCoupon = async () => {
    setState({
      ...state,
      coupon: latestCoupon,
    });
  };

  useEffect(() => {
    if (state.actualSaleRate && state.saleRate && state.quantity) {
      const rateDiff = (state.actualSaleRate - state.saleRate) * state.quantity;

      // Update the rateDiff in the state
      setState((prevState) => ({
        ...prevState,
        rateDiff: rateDiff,
      }));
    }
  }, [state.actualSaleRate, state.saleRate, state.quantity]);

  // Add item to que
  const addItem = () => {
    if (
      !state.coupon ||
      !state.itemCode ||
      !state.vehical ||
      !state.partyId ||
      !state.quantity ||
      !state.amount
    ) {
      return message.error(
        `Please type ${
          !state.coupon
            ? "Coupon Number"
            : !state.itemCode
            ? "Item Code"
            : !state.vehical
            ? "Vehical"
            : !state.partyId
            ? "Account Number"
            : !state.quantity
            ? "quantity"
            : !state.amount
            ? "Credit Amount"
            : ""
        }`
      );
    } else {
      setItemsQueue([...itemsQueue, state]);
      if (refrences.coupon === "automatic") {
        transferCoupon();
        state.coupon = latestCoupon + 1;
        setLatestCoupon(state.coupon);
      }
      clearState();

      if (refrences.coupon === "automatic") {
        setState((prevState) => ({
          ...prevState,
          coupon: latestCoupon,
        }));
      }

      if (refrences.coupon === "automatic") {
        const nextInput = inputRefs["accountName"];
        if (nextInput) {
          nextInput.focus();
        }
      } else {
        const nextInput = inputRefs["coupon"];
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const addSale = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const _refrences = await getSiteRefrence(access_token);
    if (_refrences.data.startingDate > dateEntered)
      return message.error("No Entry Beyond Financial Year Starting Date");
    if (_refrences.data.endingDate < dateEntered)
      return message.error("No Entry after Financial Year Date");
    if (_refrences.data.entryAllowed === false)
      return message.error("No Entry Allowed");
    setIsVisible(false);
    setType("SAVE");
    setFieldsShow(true);
  };
  const editItem = async () => {
    if (state.id) {
      if (
        !state.coupon ||
        !state.itemCode ||
        !state.vehical ||
        !state.partyId ||
        !state.quantity ||
        !state.amount
      ) {
        return message.error(
          `Please type ${
            !state.coupon
              ? "Coupon Number"
              : !state.itemCode
              ? "Item Code"
              : !state.vehical
              ? "Vehical"
              : !state.partyId
              ? "Account Number"
              : !state.quantity
              ? "quantity"
              : !state.amount
              ? "Credit Amount"
              : ""
          }`
        );
      }
      await updateSingleApi();
    } else {
      if (
        !state.coupon ||
        !state.itemCode ||
        !state.vehical ||
        !state.partyId ||
        !state.quantity ||
        !state.amount
      ) {
        return message.error(
          `Please type ${
            !state.coupon
              ? "Coupon Number"
              : !state.itemCode
              ? "Item Code"
              : !state.vehical
              ? "Vehical"
              : !state.partyId
              ? "Account Number"
              : !state.quantity
              ? "quantity"
              : !state.amount
              ? "Credit Amount"
              : ""
          }`
        );
      }
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);

    clearState();
  };
  console.log(itemsQueue, "items");

  // Caling Save API
  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          slipDate: curr.slipDate,
          couponNo: Number(curr.coupon),
          partyId: Number(curr.partyId),
          vehicalId: Number(curr.vehical),
          itemCode: curr.itemCode,
          quantity: Number(curr.quantity),
          saleRate: Number(curr.saleRate),
          actualSaleRate: Number(curr.actualSaleRate),
          purchaseRate: Number(curr.purchaseRate),
          rateDiff: Number(curr.rateDiff),
          amount: Number(curr.amount),
          description: curr.description,

          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
        },
      ];
    }, []);
    console.log(payload, "payyy");
    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      message.error("An error occurred while saving!");
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes
    }
    // const result = await saveData(payload, access_token);
    // if (result.success) {
    //   clearStates();
    //   message.success(result.message || "Successfully entered!");
    //   // Enable the button again if the save was successful
    //   setIsButtonDisabled(false);
    // } else {
    //   // Enable the button again if the save failed
    //   setIsButtonDisabled(false);
    // }
  };

  // Edit Data

  const [editPopup, setEditpopup] = useState(false);
  const edit = async () => {
    setEditpopup(true);
    // if (!dateEntered) {
    // } else {
    //   if (!shift) return message.error("Please type shift!");
    //   const results = await getDataByEnteredOn(
    //     dateEntered,
    //     shift,
    //     access_token
    //   );
    //   if (results.success) {
    //     console.log(results, "ressaaaaa");
    //     const payload = results.data.reduce((acc, curr) => {
    //       return [
    //         ...acc,
    //         {
    //           id: curr.id,
    //           dateEntered: curr.enteredOn,
    //           shift: curr.shift,
    //           slipDate: curr.slipDate,
    //           coupon: curr.couponNo,
    //           partyId: Number(curr.partyId),
    //           partyName: curr.party.partyName,
    //           vehical: Number(curr.vehicalId),
    //           vehicalNo: curr.vehical.regNumber,
    //           itemCode: curr.itemCode,
    //           itemName: curr.item.itemName,
    //           quantity: Number(curr.quantity),
    //           saleRate: Number(curr.saleRate),
    //           purchaseRate: Number(curr.purchaseRate),
    //           rateDiff: Number(curr.rateDiff),
    //           amount: Number(curr.amount),
    //           items: state.items,
    //         },
    //       ];
    //     }, []);
    //     setItemsQueue(payload);
    //     itemsQueue[editedItem] = state;
    //     // setEditpopup(false);
    //     await editHandler();
    //     setType("EDIT");
    //   } else {
    //     message.error(results.message);
    //   }
    // }
  };

  const editHandler = async () => {
    if (!editCoupon) return message.error("Please type Coupon number!");
    const results = await getDataByCoupon(editCoupon, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            slipDate: curr.slipDate,
            coupon: curr.couponNo,
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            vehical: Number(curr.vehicalId),
            vehicalNo: curr.vehical.regNumber,
            itemCode: curr.itemCode,
            itemName: curr.item.itemName,
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            amount: Number(curr.amount),
            rateDiff: Number(curr.rateDiff),
            description: curr.description,

            items: state.items,
            parties: state.parties,
            vehicals: state.vehicals,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      // setEditCoupon("");
      setType("EDIT");
    } else {
      setEditCoupon("");
      setEditpopup(false);
      message.error(results.message);
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      id: state.id,
      slipDate: state.slipDate,
      couponNo: Number(state.coupon),
      partyId: Number(state.partyId),
      vehicalId: Number(state.vehical),
      itemCode: state.itemCode,
      quantity: Number(state.quantity),
      saleRate: Number(state.saleRate),
      purchaseRate: Number(state.purchaseRate),
      rateDiff: Number(state.rateDiff),
      description: state.description,

      amount: Number(state.amount),
      // items: state.items,
    };

    console.log(payload, "payyyyyyyyy");
    const response = await updateSale(payload, access_token);
    if (response.success) {
      itemsQueue[editedItem] = state;
      await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  // Delete Single Entry

  const deleteCoupon = async (id) => {
    const results = await deleteSingleCoupon(id, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id) => {
    console.log("deleteSingle");
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteCoupon(id),
    });
  };

  // Delete By Date

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deleteCreditHandler = async () => {
    const results = await deleteByDate(dateEntered, shift, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      setDeletepopup(false);
      message.error(results.message);
      setDateEntered("");
      setShift("");
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Credit Sale?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteCreditHandler(),
    });
  };

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
              console.log(itemsQueue, "edit");
            }}
          >
            Edit
          </button>
        </Menu.Item>
        <Menu.Item key="1">
          <button
            onClick={() => {
              itemsQueue[index].id
                ? confirmDelete(itemsQueue[index].id)
                : deleteItem(index);
            }}
          >
            {" "}
            Delete
          </button>
        </Menu.Item>
      </Menu>
    );
  };

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "amount") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          // Add more field names as per your requirement
          "slipDate",
          "coupon",
          "accountName",
          // "partyId",
          "vehical",
          "description",
          "quantity",
          // "saleRate",
          "amount",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
            nextInput.select();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black lube-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6 mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              CREDIT SALE ENTRY LOOSE COUPUNS
            </h3>
          </div>
          <div className="bg-blue-500">
            <div className="flex content-center pt-5 ml-11">
              <input
                type="number"
                placeholder="Current Balance "
                className="text-black inpTxt p-2 h-9 ml-3 mb-3"
              />

              <input
                type="number"
                placeholder="Credit Limit"
                className="text-black inpTxt p-2 h-9 ml-3 mb-3"
              />
            </div>
            <div
              className="flex content-center pb-3 ml-11 mt-5"
              style={{
                display: "flow-root",
              }}
            >
              <input
                type="date"
                className="text-black inpTxt p-2 h-9 ml-3 mb-3"
                name="dateEntered"
                value={dateEntered}
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />

              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                onChange={(e) => setShift(e.target.value)}
                className=" text-black inpTxt p-1 h-9 ml-3 w-36"
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              <input
                type="text"
                name=""
                placeholder="S/M ID "
                value={user.id}
                className=" text-black inpTxt p-1 h-9 ml-3 w-36"
              />
              <input
                type="text"
                name=""
                placeholder="Name"
                value={user.name}
                className=" bg-white text-black inpTxt p-1 h-9 ml-3 w-52"
              />
              {fieldsShow && refrences.coupon === "manual" && (
                <Select
                  showSearch
                  placeholder="Customer Name"
                  className=" bg-white text-white  inpTxt  p-1 h-9 ml-3 w-28"
                  optionFilterProp="children"
                  value={state.partyName || "Customer Name"}
                  onChange={(e) => {
                    const { PartyName } = state.parties.find(
                      (el) => el.partyId === e
                    );
                    setState({
                      ...state,
                      partyId: e,
                      partyName: PartyName,
                    });
                  }}
                >
                  {state.parties &&
                    state.parties.map((el) => (
                      <Option value={el.partyId}>{el.PartyName}</Option>
                    ))}
                </Select>
              )}
              {fieldsShow && refrences.coupon === "issued" && (
                <input
                  readOnly
                  type="text"
                  value={state.partyName}
                  name="partyName"
                  placeholder="PartyName"
                  className=" text-black inpTxt p-1 h-9 ml-3 w-28"
                  onKeyDown={handleEnterKey}
                  ref={(ref) => addInputFieldRef(ref)}
                />
              )}
              <input
                type="text"
                name=""
                placeholder="Report No"
                className=" text-black inpTxt p-1 h-9 ml-3 w-28"
              />
            </div>
          </div>

          <div className="">
            {fieldsShow && (
              <div className="flex content-center flex-wrap pt-5 ml-11">
                <input
                  type="text"
                  name="BlockId"
                  defaultValue={1}
                  placeholder="Blaock ID"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                />
                <input
                  type="date"
                  name="slipDate"
                  placeholder="Slip Date"
                  className="bg-black dateInp text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-28"
                  value={state.slipDate}
                  onChange={onChangeText}
                  onKeyDown={(e) => handleEnterKey(e, "slipDate")}
                  ref={(ref) => addInputFieldRef(ref, "slipDate")}
                />
                {(refrences.coupon === "manual" ||
                  refrences.coupon === "issued") && (
                  <input
                    type="Number"
                    name="coupon"
                    placeholder="Coupon#"
                    className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                    value={state.coupon}
                    onChange={onChangeText}
                    onKeyDown={(e) => handleEnterKey(e, "coupon")}
                    ref={(ref) => addInputFieldRef(ref, "coupon")}
                  />
                )}
                {refrences.coupon === "automatic" && (
                  <input
                    readOnly
                    type="Number"
                    name="coupon"
                    placeholder="Coupon#"
                    className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                    // value={latestCoupon}
                    value={state.coupon}
                    onChange={onChangeText}
                    onKeyDown={handleEnterKey}
                    ref={(ref) => addInputFieldRef(ref)}
                  />
                )}
                {(refrences.coupon === "manual" ||
                  refrences.coupon === "automatic") && (
                  <Select
                    showSearch
                    name="accountName"
                    placeholder="A/C No."
                    className="ant-select bg-black text-white mt-2 ml-3 inpTxt  p-1 h-9  w-56"
                    optionFilterProp="children"
                    value={state.partyId || "A/C No."}
                    onChange={(e) => {
                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: _party.PartyName,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: "",
                        });
                      }
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "accountName")}
                    ref={(ref) => addInputFieldRef(ref, "accountName")}
                  >
                    <Option value={0}>None</Option>
                    {state.parties &&
                      state.parties.map((el) => (
                        <Option
                          value={el.partyId}
                        >{`${el.partyId} - ${el.PartyName}`}</Option>
                      ))}
                  </Select>
                )}
                {refrences.coupon === "issued" && (
                  <input
                    readOnly
                    type="text"
                    value={state.partyId}
                    name="partyId"
                    placeholder="Party Id"
                    onKeyDown={(e) => handleEnterKey(e, "partyId")}
                    ref={(ref) => addInputFieldRef(ref, "partyId")}
                    className="custom-select bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-56"
                  />
                )}

                {state.vehicals && (
                  <Select
                    showSearch
                    placeholder="Vehical No."
                    className="ant-select bg-black text-white mt-2 ml-1 inpTxt  p-1 h-9  w-32 "
                    name="vehical"
                    optionFilterProp="children"
                    value={state.vehical || "Vehical No."}
                    onChange={(e) => {
                      if (e === 0) {
                        // Check if "None" is selected
                        setState({
                          ...state,
                          vehical: 0,
                          vehicalNo: "", // Clear vehicalNo when "None" is selected
                        });
                      } else {
                        const _party = state.vehicals.find((el) => el.id === e);
                        if (_party) {
                          setState({
                            ...state,
                            vehical: e,
                            vehicalNo: _party.regNumber,
                          });
                        }
                      }
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "vehical")}
                    ref={(ref) => addInputFieldRef(ref, "vehical")}
                  >
                    <Option value={0}>None</Option>
                    {state.vehicals.map((el) => (
                      <Option value={el.id}>{el.regNumber}</Option>
                    ))}
                  </Select>
                )}
                <input
                  type="text"
                  value={state.description}
                  name="description"
                  placeholder="Description"
                  onChange={onChangeText}
                  onKeyDown={(e) => handleEnterKey(e, "description")}
                  ref={(ref) => addInputFieldRef(ref, "description")}
                  className="custom-select bg-black text-white inpTxt text-sm mt-2 p-2 h-9 ml-1  w-56"
                />

                <Select
                  className="ant-select bg-black text-white  mt-2  ml-1 inpTxt  p-1 h-9  w-36 "
                  showSearch
                  name="itemCode"
                  placeholder="Select item"
                  optionFilterProp="children"
                  value={state.itemCode || "Item"}
                  onChange={(e) => {
                    if (e === 0) {
                      // Check if "None" is selected
                      setState({
                        ...state,
                        itemCode: 0,
                        itemName: "", // Clear itemName when "None" is selected
                      });
                    } else {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "itemCode")}
                  ref={(ref) => addInputFieldRef(ref, "itemCode")}
                >
                  <Option value={0}>None</Option>
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>{`${el.itemCode}`}</Option>
                  ))}
                </Select>
                <Select
                  className="ant-select bg-black text-white mt-2 ml-1 inpTxt  p-1 h-9  w-52 "
                  showSearch
                  placeholder="Select Product Name"
                  name="itemName"
                  optionFilterProp="children"
                  value={state.itemName || "Prodct Name"}
                  onChange={(e) => {
                    if (e === 0) {
                      // Check if "None" is selected
                      setState({
                        ...state,
                        itemCode: 0,
                        itemName: "", // Clear itemName when "None" is selected
                      });
                    } else {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "itemName")}
                  ref={(ref) => addInputFieldRef(ref, "itemName")}
                  // onChange={(e) => {
                  //   const { itemName: productName } = state.items.find(
                  //     (el) => el.itemCode === e
                  //   );
                  //   setState({ ...state, itemCode: e, itemName: productName });
                  // }}
                >
                  <Option value={0}>None</Option>

                  {state.items.map((el) => (
                    <Option value={el.itemCode}>{el.itemName}</Option>
                  ))}
                </Select>
                <input
                  type="text"
                  name="quantity"
                  placeholder="Quantity"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  value={state.quantity}
                  onChange={(e) => {
                    if (state.saleRate) {
                      setState({
                        ...state,
                        amount: parseFloat(
                          e.target.value * state.saleRate
                        ).toFixed(2),
                        quantity: e.target.value,
                      });
                    } else {
                      setState({ ...state, quantity: e.target.value });
                    }
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "quantity")}
                  ref={(ref) => addInputFieldRef(ref, "quantity")}
                />
                <input
                  type="text"
                  readOnly
                  name="saleRate"
                  placeholder="Sale Rate"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  value={state.saleRate}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        amount: e.target.value * state.quantity,
                      });
                    } else {
                      setState({ ...state, saleRate: e.target.value });
                    }
                  }}
                />
                <input
                  type="hidden"
                  readOnly
                  name="rateDiff"
                  placeholder="Rate Diff"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  value={
                    (state.actualSaleRate - state.saleRate) * state.quantity
                  }
                />
                <input
                  type="text"
                  name="amount"
                  placeholder="Amount"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-28"
                  value={state.amount}
                  onChange={(e) => {
                    if (state.amount) {
                      setState({
                        ...state,
                        quantity: parseFloat(
                          e.target.value / state.saleRate
                        ).toFixed(2),
                        amount: e.target.value,
                      });
                    } else {
                      setState({ ...state, amount: e.target.value });
                    }
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "amount")}
                  ref={(ref) => addInputFieldRef(ref, "amount")}
                />

                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-3 mt-2 h-9py-1 px-4 rounded"
                  >
                    EDIT
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-1 mr-3 py-1 h-9 mt-2 px-4 text-xs font-medium rounded"
                  >
                    ADD +
                  </button>
                )}
              </div>
            )}
          </div>

          <div className="div">
            <div
              style={{ overflow: "auto", maxHeight: "400px" }}
              className="flex"
            >
              <div
                style={{ position: "sticky", top: "0" }}
                className="overflow-x-auto   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full"
              >
                <table className=" w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500 text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        S.N
                      </th>
                      <th
                        className=" pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        VEHICLE
                      </th>
                      {/* <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        PARTY_ID
                      </th> */}
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        CUSTOMER NAME
                      </th>
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Description
                      </th>
                      {/* <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        ITEM_ID
                      </th> */}
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        ITEM DESCRIPTION
                      </th>
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        COUPON#
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        QUANTITY
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Sale Rate
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Amount
                      </th>
                      {(type === "EDIT" || type === "SAVE") && (
                        <th
                          className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                          scope="col"
                        >
                          ACTION
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className=" pt-3 pb-3  pl-2 pr-1 ">{i + 1}</td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium ">{ele.vehicalNo}</p>
                          </td>{" "}
                          {/* <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.partyId}</p>
                          </td> */}
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.partyName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.description}</p>
                          </td>
                          {/* <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.itemCode}</p>
                          </td> */}
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.itemName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.coupon}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.quantity}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.saleRate}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.amount}</p>
                          </td>
                          {(type === "EDIT" || type === "SAVE") && (
                            <td className="px-6 fs-15 py-3  ">
                              <Dropdown
                                overlay={menu(i)}
                                placement="bottomLeft"
                              >
                                <Button>Action</Button>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex mb-2 justify-between">
              <div className="flex pl-10">
                {type === "ADD" && (
                  <button
                    onClick={addSale}
                    className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />
                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={save}
                    className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                      isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isButtonDisabled}
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}

                {type === "ADD" && (
                  <button
                    onClick={edit}
                    className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                <button
                  onClick={() => deletePurchase()}
                  className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                  disabled={type !== "ADD"}
                >
                  <AiFillDelete className="mr-2 mt-1" />

                  <span>Delete</span>
                </button>
                <button
                  onClick={clearStates}
                  className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  {" "}
                  <BiExit className="mr-2 mt-1" />
                  {type === "EDIT" ? "Done" : "Exit"}
                </button>
              </div>
              <div className="flex justify-end">
                <label className="mt-4 w-12">Total: </label>
                <input
                  type="text"
                  readOnly
                  placeholder=""
                  name=""
                  id=""
                  value={total}
                  className="bg-black p-2 h-9 ml-3 mb-3 mt-2"
                  // className="mt-2 pl-3 pt-1 pb-1 w-32 bg-black text-white outline-none"
                />
              </div>
              <div className="flex content-end mt-3 bg-white justify-end"></div>
              {isVisible && (
                <div>
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                    onClick={orderByAsc}
                  >
                    <img src={`./img/first.png`} alt="" />
                  </button>
                  {typeLast === "LAST" && (
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      onClick={onePreDate}
                    >
                      <img src={`./img/previous.png`} alt="" />
                    </button>
                  )}

                  {typeLast === "LAST" && (
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      onClick={oneNextDate}
                    >
                      <img src={`./img/next.png`} alt="" />
                    </button>
                  )}

                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                    onClick={orderByDesc}
                  >
                    <img src={`./img/latest.png`} alt="" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type Coupon number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={editCoupon}
            onChange={(e) => setEditCoupon(e.target.value)}
          />
        </div>
      </Popup>
      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <h2>Please type Date for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="date"
            value={dateEntered}
            onChange={(e) => setDateEntered(e.target.value)}
          />
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={shift}
            onChange={(e) => setShift(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default Credits;
